import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { NLPSearchJSONResultFormat } from '../types';
export var getTypedJSONResultData = function getTypedJSONResultData(answerString) {
  var parsed = JSON.parse(answerString);
  if ('user_metadata' in parsed && !!parsed.user_metadata) {
    return {
      parsedResult: parsed.user_metadata,
      parsedType: NLPSearchJSONResultFormat.WHO
    };
  } else if ('user_metadata_only_cards' in parsed && !!parsed.user_metadata_only_cards) {
    return {
      parsedResult: parsed.user_metadata_only_cards,
      parsedType: NLPSearchJSONResultFormat.PERSON
    };
  } else if ('user_metadata_with_activity' in parsed && !!parsed.user_metadata_with_activity) {
    return {
      parsedResult: parsed.user_metadata_with_activity,
      parsedType: NLPSearchJSONResultFormat.WORK
    };
  } else if ('team_metadata' in parsed && !!parsed.team_metadata) {
    return {
      parsedResult: parsed.team_metadata,
      parsedType: NLPSearchJSONResultFormat.TEAM
    };
  } else {
    // This line should never be reached, this means that an unsupported type was in the JSON result
    return {
      parsedResult: parsed,
      parsedType: undefined
    };
  }
};
var mapRecentActivity = function mapRecentActivity(activity) {
  return {
    title: activity.title,
    url: activity.url,
    containerName: activity.containerName,
    event: activity.event,
    timestamp: activity.timestamp,
    iconUrl: activity.iconUrl,
    contributors: activity.contributors.slice(0, MAX_OTHERS_TO_SHOW).map(function (contributor) {
      return {
        name: contributor.name,
        id: contributor.accountId
      };
    }),
    othersCount: activity.othersCount
  };
};
var mapTeam = function mapTeam(team) {
  return {
    name: team.displayName,
    avatarUrl: team.smallAvatarImageUrl,
    url: "/wiki/people/team/".concat(team.id),
    memberCount: team.memberCount
  };
};
var mapAdditionalMatch = function mapAdditionalMatch(match) {
  var _match$email;
  return {
    name: match.name,
    avatar_url: match.avatar_url,
    profile_url: match.profile_url,
    job_title: match.title,
    email: (_match$email = match.email) !== null && _match$email !== void 0 ? _match$email : ''
  };
};

// Collaborators, contributors and additional matches are expected to be at most 3
var MAX_OTHERS_TO_SHOW = 3;
export var getTypedJSONResultDataAssistanceService = function getTypedJSONResultDataAssistanceService(answerString) {
  var parsed = JSON.parse(answerString);
  if ('enriched_activity_output' in parsed) {
    var _main_user_profile$us, _main_user_profile$us2, _main_user_profile$us3, _main_user_profile$us4;
    var _parsed$enriched_acti = parsed.enriched_activity_output,
      main_user_profile = _parsed$enriched_acti.main_user_profile,
      additional_matches = _parsed$enriched_acti.additional_matches;
    return {
      parsedResult: [{
        name: main_user_profile.user_base_data.name,
        email: main_user_profile.user_base_data.email,
        time: main_user_profile.time,
        profile_url: main_user_profile.user_base_data.profile_url,
        avatar_url: main_user_profile.user_base_data.avatar_url,
        recentActivity: main_user_profile.recent_activity.map(mapRecentActivity),
        department: (_main_user_profile$us = main_user_profile.user_base_data.extended_profile) === null || _main_user_profile$us === void 0 ? void 0 : _main_user_profile$us.department,
        job_title: (_main_user_profile$us2 = main_user_profile.user_base_data.extended_profile) === null || _main_user_profile$us2 === void 0 ? void 0 : _main_user_profile$us2.job_title,
        location: (_main_user_profile$us3 = main_user_profile.user_base_data.extended_profile) === null || _main_user_profile$us3 === void 0 ? void 0 : _main_user_profile$us3.location,
        organization: (_main_user_profile$us4 = main_user_profile.user_base_data.extended_profile) === null || _main_user_profile$us4 === void 0 ? void 0 : _main_user_profile$us4.organization,
        viewAllLink: main_user_profile.view_all_activity_url
      }].concat(_toConsumableArray(additional_matches.slice(0, MAX_OTHERS_TO_SHOW).map(function (x) {
        return _objectSpread(_objectSpread({}, mapAdditionalMatch(x)), {}, {
          recentActivity: [],
          viewAllLink: ''
        });
      }))),
      parsedType: NLPSearchJSONResultFormat.WORK
    };
  } else if ('enriched_profile_output' in parsed) {
    var _main_user_profile$us5, _main_user_profile$us6, _main_user_profile$us7, _main_user_profile$us8, _main_user_profile$re, _main_user_profile$te;
    var _parsed$enriched_prof = parsed.enriched_profile_output,
      _main_user_profile = _parsed$enriched_prof.main_user_profile,
      _additional_matches = _parsed$enriched_prof.additional_matches;
    return {
      parsedResult: [{
        account_id: _main_user_profile.user_base_data.account_id,
        name: _main_user_profile.user_base_data.name,
        email: _main_user_profile.user_base_data.email,
        profile_url: _main_user_profile.user_base_data.profile_url,
        avatar_url: _main_user_profile.user_base_data.avatar_url,
        job_title: (_main_user_profile$us5 = _main_user_profile.user_base_data.extended_profile) === null || _main_user_profile$us5 === void 0 ? void 0 : _main_user_profile$us5.job_title,
        location: (_main_user_profile$us6 = _main_user_profile.user_base_data.extended_profile) === null || _main_user_profile$us6 === void 0 ? void 0 : _main_user_profile$us6.location,
        department: (_main_user_profile$us7 = _main_user_profile.user_base_data.extended_profile) === null || _main_user_profile$us7 === void 0 ? void 0 : _main_user_profile$us7.department,
        organization: (_main_user_profile$us8 = _main_user_profile.user_base_data.extended_profile) === null || _main_user_profile$us8 === void 0 ? void 0 : _main_user_profile$us8.organization,
        time: _main_user_profile.time,
        collaborators: _main_user_profile.collaborators.slice(0, 6).map(function (user) {
          var _user$extended_profil, _user$extended_profil2, _user$extended_profil3, _user$extended_profil4;
          return {
            name: user.name,
            picture: user.avatar_url,
            title: (_user$extended_profil = (_user$extended_profil2 = user.extended_profile) === null || _user$extended_profil2 === void 0 ? void 0 : _user$extended_profil2.job_title) !== null && _user$extended_profil !== void 0 ? _user$extended_profil : null,
            url: user.profile_url,
            accountId: user.account_id,
            department: (_user$extended_profil3 = (_user$extended_profil4 = user.extended_profile) === null || _user$extended_profil4 === void 0 ? void 0 : _user$extended_profil4.department) !== null && _user$extended_profil3 !== void 0 ? _user$extended_profil3 : null,
            email: user.email
          };
        }),
        containers: _main_user_profile.collaboration_spaces.map(function (container) {
          return {
            name: container.name,
            containerType: container.container_type,
            url: container.url,
            iconUrl: container.icon_url
          };
        }),
        recentActivity: (_main_user_profile$re = _main_user_profile.recent_activity) === null || _main_user_profile$re === void 0 ? void 0 : _main_user_profile$re.map(mapRecentActivity),
        viewAllLink: _main_user_profile.view_all_activity_url,
        teams: (_main_user_profile$te = _main_user_profile.teams) === null || _main_user_profile$te === void 0 ? void 0 : _main_user_profile$te.map(mapTeam)
      }].concat(_toConsumableArray(_additional_matches.slice(0, MAX_OTHERS_TO_SHOW).map(mapAdditionalMatch))),
      parsedType: NLPSearchJSONResultFormat.WHO
    };
  } else if ('team_metadata' in parsed) {
    return {
      parsedResult: parsed.team_metadata,
      parsedType: NLPSearchJSONResultFormat.TEAM
    };
  } else {
    // This line should never be reached, this means that an unsupported type was in the JSON result
    return {
      parsedResult: {},
      parsedType: undefined
    };
  }
};